import { Pipe, PipeTransform } from '@angular/core';

import { ShipmentRoute } from '../../../pages/overview/models/shipment';

@Pipe({
  name: 'shouldShowConfirmedRouting',
  standalone: true
})
export class ShouldShowConfirmedRoutingPipe implements PipeTransform {
  transform(allRoutes: ShipmentRoute[] | null): boolean {
    if (allRoutes && allRoutes.length > 0) {
      return allRoutes.some(route => route.sequenceNo !== null);
    }

    return false;
  }
}
